
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 132172","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 132180","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M22.114 26.8H8.7c-4.023 0-6.7-2.011-6.7-6.7v-9.4C2 6.011 4.682 4 8.7 4h13.414c4.023 0 6.7 2.011 6.7 6.7v9.387c.005 4.697-2.677 6.713-6.7 6.713z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M22.114 11.375l-4.2 3.352a4.245 4.245 0 01-5.029 0l-4.18-3.352"}})])])
          )
        }
      }
    